import { useState } from 'react';
import { faqs } from '@/mocks/comics';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <section className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              关于无遮韩国免费漫画大全的常见疑问解答
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                >
                  <h3 className="text-sm font-medium text-foreground-950 pr-4">
                    {faq.question}
                  </h3>
                  <i
                    className={`${openIndex === index ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-foreground-400 flex-shrink-0 transition-transform duration-200`}
                  ></i>
                </button>
                {openIndex === index && (
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}